import { render, staticRenderFns } from "./costPerId.vue?vue&type=template&id=3ccd68a5"
import script from "./costPerId.vue?vue&type=script&lang=js"
export * from "./costPerId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports